import { Component as ViewAllIcon } from 'icons/icon-ui--forkspoon.svg';
import { Component as DinnerIcon } from 'icons/icon-ui--ramen.svg';
import { Component as LunchIcon } from 'icons/icon-ui--burger.svg';
import { Component as BreakfastIcon } from 'icons/icon-ui--breakfast.svg';
import { Component as QuickEatsIcon } from 'icons/icon-ui--salad.svg';
import { Component as GroceryIcon } from 'icons/icon-ui--grocery.svg';

export enum TopLevelFilters {
  ViewAll = 'ViewAll',
  Dinner = 'Dinner',
  Lunch = 'Lunch',
  Breakfast = 'Breakfast',
  QuickEats = 'QuickEats',
  Grocery = 'Grocery'
}

export type AllFilters = {
  [TopLevelFilters.ViewAll]: string[],
  [TopLevelFilters.Dinner]: string[];
  [TopLevelFilters.Lunch]: string[];
  [TopLevelFilters.Breakfast]: string[];
  [TopLevelFilters.QuickEats]: string[];
  [TopLevelFilters.Grocery]: string[];
}

export type SelectedFilter = {
  [key in TopLevelFilters]?: string[];
}

export const initialFilter = {
  [TopLevelFilters.ViewAll]: ['All'],
};

// create sets of filterTags under the top level filters for hub filtering
export const defaultFilterTags = {
  [TopLevelFilters.ViewAll]: ['All', '30 min or less', 'high-protein', 'gluten-free', 'high fiber', '<600 calories'],
  [TopLevelFilters.Dinner]: ['All', '30 min or less', 'high-protein', 'gluten-free', 'high fiber', '<600 calories'],
  [TopLevelFilters.Lunch]: ['All', '30 min or less', 'high-protein', 'gluten-free', 'high fiber', '<600 calories'],
  [TopLevelFilters.Breakfast]: ['All', '30 min or less', 'high-protein', 'gluten-free', 'high fiber', '<600 calories'],
  [TopLevelFilters.QuickEats]: ['All', '30 min or less', 'high-protein', 'gluten-free', 'high fiber', '<600 calories'],
  [TopLevelFilters.Grocery]: ['All', 'staples', 'proteins', 'dairy alternatives', 'cereal & granola', 'beverages', 'snacks', 'desserts'],
};

export const getFilterDisplayMap = (deliveryDateRange?: string) => ({
  [TopLevelFilters.ViewAll]: {
    displayName: deliveryDateRange
      ? `View All | ${deliveryDateRange}`
      : 'View All',
    icon: ViewAllIcon,
  },
  [TopLevelFilters.Breakfast]: {
    displayName: 'Breakfast',
    icon: BreakfastIcon,
  },
  [TopLevelFilters.Lunch]: {
    displayName: 'Lunch',
    icon: LunchIcon,
  },
  [TopLevelFilters.Dinner]: {
    displayName: 'Dinner',
    icon: DinnerIcon,
  },
  [TopLevelFilters.QuickEats]: {
    displayName: 'Quick Eats & Sides',
    icon: QuickEatsIcon,
  },
  [TopLevelFilters.Grocery]: {
    displayName: 'Grocery',
    icon: GroceryIcon,
  },
});

export enum DropdownFilterCategory {
  PRODUCT_TYPE = 'productType',
  COOK_TIME = 'cookTime',
}

export type SelectedDropdownFilters = {
  [DropdownFilterCategory.PRODUCT_TYPE]: string[],
  [DropdownFilterCategory.COOK_TIME]: string[];
}

export const initialDropdownFilter = {
  productType: [],
  cookTime: [],
};

export const LAST_LTO_WEEK_MENU_ID = 1533;
